var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorskpacePremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "worskpace-premium-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17356",
    "data-name": "Ret\\xE2ngulo 17356",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7420",
    "data-name": "Caminho 7420",
    d: "M10.92,12.75,12,11.93l1.07.81a.5.5,0,0,0,.78-.55l-.42-1.36,1.2-.95A.494.494,0,0,0,14.31,9h-1.4l-.43-1.34a.5.5,0,0,0-.95,0L11.09,9H9.68a.5.5,0,0,0-.31.89l1.19.95-.42,1.36A.5.5,0,0,0,10.92,12.75ZM6,21.61a1.007,1.007,0,0,0,1.32.95L12,21l4.68,1.56A1,1,0,0,0,18,21.61V15.28a8,8,0,1,0-12,0ZM12,4a6,6,0,1,1-6,6A6,6,0,0,1,12,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorskpacePremiumIcon);
export default __webpack_public_path__ + "static/media/worskpace-premium-icon.393c8fbf699760c47ea5be2c1fe2f630.svg";
export { ForwardRef as ReactComponent };